// Prevent zooming via keyboard shortcuts and gestures
export const preventZoom = () => {
  // Prevent zoom with Ctrl/Cmd + Plus/Minus/0
  document.addEventListener('keydown', (e) => {
    if (
      (e.ctrlKey || e.metaKey) &&
      (e.key === '+' || e.key === '-' || e.key === '=' || e.key === '0')
    ) {
      e.preventDefault();
      return false;
    }
    // Prevent zoom with Ctrl/Cmd + Mouse Wheel
    if ((e.ctrlKey || e.metaKey) && e.deltaY) {
      e.preventDefault();
      return false;
    }
  }, { passive: false });

  // Prevent pinch zoom
  let lastTouchEnd = 0;
  document.addEventListener('touchend', (e) => {
    const now = Date.now();
    if (now - lastTouchEnd <= 300) {
      e.preventDefault();
    }
    lastTouchEnd = now;
  }, { passive: false });

  // Prevent double-tap zoom
  let lastTap = 0;
  document.addEventListener('touchend', (e) => {
    const currentTime = new Date().getTime();
    const tapLength = currentTime - lastTap;
    if (tapLength < 300 && tapLength > 0) {
      e.preventDefault();
    }
    lastTap = currentTime;
  }, { passive: false });

  // Prevent context menu (right-click) that might allow zoom
  document.addEventListener('contextmenu', (e) => {
    // Allow context menu on input/textarea for copy/paste
    if (e.target.tagName === 'INPUT' || e.target.tagName === 'TEXTAREA') {
      return;
    }
    e.preventDefault();
    return false;
  });

  // Disable zoom on window resize
  const disableZoom = () => {
    document.body.style.zoom = '1';
    // Don't use transform on body as it breaks fixed positioning
    // Instead, apply zoom prevention via viewport meta tag and CSS
    if (window.devicePixelRatio !== 1) {
      // Use zoom instead of transform to avoid breaking fixed positioning
      document.documentElement.style.zoom = '1';
    }
  };

  window.addEventListener('resize', disableZoom);
  window.addEventListener('orientationchange', disableZoom);
  
  // Set initial zoom
  disableZoom();
};
